export default __webpack_public_path__ + "static/gordon-f4875970f86772fe6e91b1f283b07fb4.png";